<!-- UnEnroll All modal -->
<ds-modal
  (onCloseModalEvent)="closeModal.emit(modalId)"
  [id]="modalId"
  [closeOthers]="true"
  [maxWidth]="496"
>
  <div class="row pad-horizontal-20">
    <div class="column twelve margin-bottom-30">
      <h3
        class="text-center margin-bottom-20"
        dsContent
        [contentPath]="'kydSmartphonePhh.unenrollHeader'"
      ></h3>
      @if (!isLastOperator) {
        <div>
          <p dsContent [contentPath]="'kydSmartphonePhh.unenrollOne'"></p>
          <ul class="bullet margin-top-20">
            <li>{{ operatorName }}</li>
          </ul>
        </div>
      }
      @if (isLastOperator) {
        <p>
          @if (policyState !== 'WA') {
            <span dsContent [contentPath]="'kydSmartphonePhh.unenrollOneLastOperator'"></span>
          }
          @if (policyState === 'WA') {
            <span dsContent [contentPath]="'kydSmartphonePhh.unenrollOneLastOperatorWA'"></span>
          }
        </p>
      }
    </div>
    <div>
      <br />
      <br />
    </div>

    <br />
    <br />
    <p class="row">
      @if (isLastOperator) {
        <span dsContent [contentPath]="'kydSmartphonePhh.unenrollOneLastOperatorConfirm'"></span>
      }
      @if (!isLastOperator) {
        <span dsContent [contentPath]="'kydSmartphonePhh.unenrollOneConfirm'"> </span>
      }
    </p>
    <div class="column twelve margin-top-20">
      <div class="row flex items-center">
        <div class="column seven">
          <button
            ds-button
            class="-outline-white"
            aria-label="No"
            (click)="closeModal.emit(modalId)"
          >
            No
          </button>
        </div>
        <div class="column five pad-left-20">
          <button
            ds-button
            class="-outline fill"
            (click)="unEnrollOne.emit()"
            aria-label="Yes, I'm Sure"
          >
            Yes, I'm Sure
          </button>
        </div>
      </div>
    </div>
  </div>
</ds-modal>
